import React from 'react'

interface IStepNavItemProps {
  active: boolean
  stepNumber: number
  title: string
  onClick: () => void
  disabled: boolean
}

const StepNavItem = ({
  active,
  stepNumber,
  title,
  onClick,
  disabled
}: IStepNavItemProps) => {
  let cellStyle = {
    backgroundColor: 'white',
    color: '#6D39D9',
    border: '1px solid #CED0D6'
  }
  let textColor = '#6C757D'
  if (active) {
    cellStyle.backgroundColor = '#6D39D9'
    cellStyle.color = 'white'
    cellStyle.border = ''
    textColor = '#6D39D9'
  }

  return (
    <div
      className="d-flex align-items-center"
      style={{
        cursor: disabled ? 'default' : 'pointer',
        userSelect: 'none'
      }}
      onClick={() => {
        if (!disabled) {
          onClick()
        }
      }}
    >
      <div
        style={{
          ...cellStyle,
          width: 20,
          height: 20,
          borderRadius: 10
        }}
        className="d-flex justify-content-center align-items-center"
      >
        {stepNumber}
      </div>
      <span
        style={{
          marginLeft: 10,
          color: textColor
        }}
      >
        {title}
      </span>
    </div>
  )
}

export default StepNavItem
